import instance from "./api";
import EndPoints from "./api-endpoints";

const caseSubmit = async (payload: any) => {
  try {
    return instance
      .post(EndPoints.createCase, payload, {
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "*/*",
        },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  } catch (error) {
    return error;
  }
};

const uploadDocuments = async (payload: FormData) => {
  try {
    const response = await instance.post(
      EndPoints.uploadDocs,
      payload,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (error: any) {
    return error.response;
  }
};


export { caseSubmit, uploadDocuments };
